import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function PedagogyBackLink({
  to,
  label,
  onClick,
}: {
  to?: string
  label: string
  onClick?: () => void
}) {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={onClick ?? (() => to && navigate(to))}
      className="inline-flex h-8 items-center gap-1.5 rounded-lg px-2 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {label}
    </button>
  )
}
